import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatContainerBaseConfig } from '../../base';
import { SolutionToolController, SolutionToolLoader } from './solutionPartInterface';
import { SolutionToolContainerProps } from './solutionPartProps';

export function createSolutionToolContainer(
    config: ChatContainerBaseConfig,
    loader: SolutionToolLoader,
    controller: SolutionToolController
): React.FC<SolutionToolContainerProps> {
    const {
        context: { useContext },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const navigate = useNavigate();
        const item = loader.useLoad(context, containerProps);

        const props = controller.useProps(context, item, {
            onNavigate() {
                if (!item.document) {
                    console.warn('No document found for solution', item);
                    return;
                }

                // Use external navigation interface like document context container
                config.external.document.open(
                    { document: item.document },
                    {
                        navigate,
                    }
                );
            },
        });

        return <View {...props} />;
    };
}
